<div class="mc-file-properties-body mc-bg-body">
  <!-- file size  -->
  <div class="mc-file-properties-property">
    <span class="text-heavy-weight">File Size:&nbsp;</span><span>{{ size | mcFileSize }}</span>
  </div>
  <!-- file last committed date  -->
  <div class="mc-file-properties-property">
    <span class="text-heavy-weight">Committed:&nbsp;</span>
    <span *ngIf="fetchingCommit">fetching...</span>
    <span *ngIf="!fetchingCommit">{{ (committedAt | date:FilePropertiesDateFormat) ?? 'uncommitted' }}</span>
  </div>
  <!-- file last modified date  -->
  <div *ngIf="showModified" class="mc-file-properties-property">
    <span class="text-heavy-weight">Modified:&nbsp;</span>
    <span>{{ modified | date:FilePropertiesDateFormat }}</span>
  </div>
  <!-- image file properties  -->
  <ng-container *ngIf="showImageProperties">
    <!-- dimensions  -->
    <div class="mc-file-properties-property">
      <span class="text-heavy-weight">Dimensions:&nbsp;</span>
      <span *ngIf="imageDimensions">{{ imageDimensions.width }} x {{ imageDimensions.height }} pixels</span>
      <span *ngIf="!imageDimensions">There was a problem getting the image dimensions.</span>
    </div>
    <!-- resolution  -->
    <div *ngIf="imageResolution" class="mc-file-properties-property">
      <span class="text-heavy-weight">Resolution:&nbsp;</span>
      <span>{{ imageResolution.x }} x {{ imageResolution.y }} dpi</span>
    </div>
  </ng-container>
</div>